var CustomiseSections;
(function (CustomiseSections) {
    CustomiseSections["VARIANT"] = "variant";
    CustomiseSections["INTERIOR"] = "interior";
    CustomiseSections["EXTERIOR"] = "colour";
    CustomiseSections["ACCESSORIES"] = "accessories";
    CustomiseSections["ACCESSORY"] = "accessory";
    CustomiseSections["PACKS"] = "options";
    CustomiseSections["JAGUARGEAR"] = "jaguar_gear";
    CustomiseSections["SERVICE_PLAN"] = "service";
    CustomiseSections["SUMMARY"] = "summary";
    CustomiseSections["SELECTIONS"] = "selections";
    CustomiseSections["DISCLAIMER"] = "disclaimer";
    CustomiseSections["STOCK"] = "stock";
})(CustomiseSections || (CustomiseSections = {}));
export default CustomiseSections;
//# sourceMappingURL=CustomiseSections.js.map